export default __webpack_public_path__ + "static/media/horror.374c5f00.png";